export default __webpack_public_path__ + "static/img-nhs-optimiser-693121645cfcad28c8478fe0a0afe3cd.jpg";